/**
 * Whether the two-pane review cockpit is enabled.
 *
 * Defaults ON — the cockpit is the delivered design. Set the Vite env var
 * `VITE_REVIEW_COCKPIT="false"` to fall back to the legacy expand/collapse
 * question list. Read defensively so a missing/undeclared env key just yields
 * the default.
 */
export function isCockpitEnabled(): boolean {
  const env = import.meta.env as unknown as Record<string, string | undefined>;
  return env.VITE_REVIEW_COCKPIT !== 'false';
}
